import { QueryClient } from '@tanstack/react-query';

/** App-wide React Query cache. Module-level so sign-out can drop the previous user's data. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});
